import { spreeIntegration } from '@Root/spree';
import '@Root/blocks';

spreeIntegration();
